import { API_ERROR_CODES, ONBOARDING_API_BASE_URL } from './index.ts';

/**
 * Search for identity information based on provided criteria
 */

export enum IdentityStatus {
  verified = 'verified',
  unverified = 'unverified',
  new = 'new',
}

export type ApiIdentitySearchResult = {
  data?: {
    status: IdentityStatus;
    csrfToken: string;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiIdentitySearch = async (email: string): Promise<ApiIdentitySearchResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/identity/search`, {
    method: 'POST',
    body: JSON.stringify({ searchStr: email }),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',

      Accept: 'application/json',
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      return {
        data: {
          ...responseJson,
          status: responseJson.exists === false ? IdentityStatus.new : responseJson.status,
        },
      } as ApiIdentitySearchResult;
    })
    .catch(() => ({
      errorCode: API_ERROR_CODES.GENERIC,
    }));
};
